import { BlobStorageAccess } from './auth.module';

export function assertBlobConfig(
  config: BlobStorageAccess | undefined,
): asserts config is BlobStorageAccess {
  const err = "'Blob storage access configuration is not defined!";
  if (!config || !(config.sas && config.url)) throw new Error(err);
}
